module.exports = __webpack_public_path__ + "static/media/img_1.fc28c347.png";